import { render, staticRenderFns } from "./BoxTitle.vue?vue&type=template&id=b91e8ebe&"
var script = {}
import style0 from "./BoxTitle.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports